import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './index.css'

createApp(App).mount('#app')
